<template>
    <span>
        <textarea :id="id" :value="value" @input="$emit('input', $event.target.value);"></textarea>
    </span>
</template>

<script>
export default {
    props: {
        redactor: {
            type: Boolean,
            default: false
        },
        locale: {
            type: String,
            default: 'en_US'
        },
        value: String
    },
    data() {
        return {
            id: null
        }
    },
    created() {
        if (this.redactor) {
            this.loadScripts();
        }
    },
    methods: {
        initRedactor() {
            const self = this;
            const $block = $('#' + self.id);
            $block.redactor({
                minHeight: $block.data('height') || 250,
                toolbarFixed: false,
                maxHeight: 250,
                lang: self.locale.substring(0, 2),
                buttons: ['html', 'format', 'bold', 'italic', 'underline', 'deleted', 'lists',
                    'image', 'video', 'table', 'link', 'alignment',
                    'horizontalrule', 'fontcolor', 'fontsize', 'fontfamily'],
                plugins: ['source', 'fontcolor', 'fontfamily', 'alignment', 'fontsize', 'table', 'video', 'imagemanager'],
                imageUpload: '?plugin=' + process.env.PLUGIN_SLUG + '&action=upload',
                imageUploadParam: 'image',
                multipleImageUpload: false,
                imageUploadFields: {
                    _csrf: $('[name="_csrf"]:first').val() || self.csrf
                },
                focus: false,
                callbacks: {
                    init: function () {
                        this.$textarea.addClass('inited');
                    },
                    sync: function (html) {
                        self.$emit('input', html);
                    },
                    change: function (html) {
                        self.$emit('input', html);
                    },

                }
            });
        },
        loadScripts() {
            const self = this;

            var sources = [
                window.wa_url + "wa-content/js/redactor/2/redactor.css",
                window.wa_url + "wa-content/js/redactor/2/redactor.min.js"
            ];
            if (self.locale !== 'en_US') {
                sources.push(window.wa_url + "wa-content/js/redactor/2/" + self.locale.substring(0, 2) + '.js');
            }

            /* Подгрузка скриптов редактирования */
            const loadScripts = self.$loadScript.series(sources);
            loadScripts.then(() => {
                this.initRedactor();
            });
        },
    },
    mounted() {
        this.id = 'vue-textarea-' + this._uid;
    }
}
</script>